import { render, staticRenderFns } from "./ScheduleResources.vue?vue&type=template&id=15e781ac&scoped=true"
import script from "./ScheduleResources.vue?vue&type=script&lang=ts"
export * from "./ScheduleResources.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e781ac",
  null
  
)

export default component.exports